import BaseError from '../BaseError'

let v: string = ''
let key: string = ''

export const initLogging = (ver: string, apiKey: string): void => {
    v = ver
    key = apiKey
    defineGlobalErrorHandler()
}

function captureError(ex: Error) {
    const errorData = {
        name: ex.name,
        message: ex.message,
        stack: ex.stack,
        ver: v,
        key: key,
    };
    console.error('captureError', JSON.stringify(errorData))
}


export const catchMethodError = (): any => {
    // @ts-ignore
    return (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
        const originalMethod = descriptor.value
        descriptor.value = function(...args: any[]) {
            try {
                return originalMethod.apply(this, args)
            } catch (error) {
                if (!(error instanceof BaseError))
                    captureError(error as BaseError);
                throw error;
            }
        }
        return descriptor
    }
}


const defineGlobalErrorHandler = () => {
    if (typeof window === 'undefined') return

    const existingOnError = window.onerror
    window.onerror = function interactyErrorHandler(event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) {
        if (error && source && source.includes('interacty.me'))
            captureError(error)

        if (existingOnError)
            return existingOnError(event, source, lineno, colno, error);

        return false;
    }
}